Greenmile.Actions = Greenmile.Actions || {};
Greenmile.Actions.ManagerNotification = {
  template: () => ({
    items: [{
      items: [
        {
          items: [
            {
              items: [
                {
                  tag: "label",
                  items: [
                    {
                      tag: "span",
                      html: "event.action.managerNotification.description",
                      attributes: {
                        class: "i18nResource",
                        id: "actionDescription"
                      }
                    }
                  ],
                  attributes: {
                    for: "actionDescription"
                  }
                }
              ]
            }
          ]
        },
        {
          items: [
            {
              items: [ 
                {
                  items: [
                    {
                      items: [
                        {
                          items: [
                            {
                              tag: "label",
                              items: [
                                {
                                  tag: "input",
                                  attributes: {
                                    type: "checkbox",
                                    id: "checkBoxDisplayPushNotification",
                                    name: "displayPushNotification",
                                    class: "modelAttribute"
                                  }
                                },
                                {
                                  tag: "span",
                                  html: "event.action.managerNotification.displayPushNotification",
                                  attributes: {
                                    class: "i18nResource"
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      attributes: {
                        id: "displayPushNotification"
                      }
                    }
                  ]
                },
                {
                  items: [
                    {
                      items: [
                        {
                          items: [
                            {
                              tag: "label",
                              items: [
                                {
                                  tag: "input",
                                  attributes: {
                                    type: "checkbox",
                                    id: "checkBoxDisplayEventDescription",
                                    name: "useEventDescription",
                                    class: "modelAttribute",
                                    disabled: "disabled"
                                  }
                                },
                                {
                                  tag: "span",
                                  html: "event.action.managerNotification.useEventDescription",
                                  attributes: {
                                    class: "i18nResource",
                                    id: "labelUseEventDescription",
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      attributes: {
                        id: "displayUseEventDescription",
                      }
                    },
                    {
                      tag: "div",
                      attributes: {
                        id: "customTitle",
                      }
                    }
                  ],
                  attributes: {
                    id: "customNotificationTitle"
                  }
                },
                {
                  items: [
                    {
                      items: [
                        {
                          items: [
                            {
                              tag: "label",
                              items: [
                                {
                                  tag: "input",
                                  attributes: {
                                    type: "checkbox",
                                    id: "checkBoxDisplayEventMessageBody",
                                    name: "useEventMessageBody",
                                    class: "modelAttribute",
                                    disabled: "disabled"
                                  }
                                },
                                {
                                  tag: "span",
                                  html: "event.action.managerNotification.useEventMessageBody",
                                  attributes: {
                                    class: "i18nResource",
                                    id: "labelUseEventMessageBody"
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      attributes: {
                        id: "displayUseEventMessageBody",
                      }
                    },
                    {
                      tag: "div",
                      attributes: {
                        id: "customBody"
                      }
                    },
                  ],
                  attributes: {
                    id: "customNotificationText"
                  }
                },
              ],
              attributes: {
                class: "fields-left-side"
              }
            },
            {
              items: [
                {
                  items: [],
                  attributes: {
                    id: "lookupListBoxDisplayGroup",
                  }
                }
              ],
              attributes: {
                class: "fields-right-side"
              }
            },
          ],
          attributes: {
            class: "fields-container"
          }
        }
      ],
      attributes: {
        id: "managerNotificationAction"
      },

    }],

  }),

  initManagerNotificationAction() {
    this.checkBoxDisplayPushNotification = document.getElementById("checkBoxDisplayPushNotification");
    this.checkBoxUseEventDescription = document.getElementById("checkBoxDisplayEventDescription");
    this.checkBoxUseEventMessageBody = document.getElementById("checkBoxDisplayEventMessageBody");
    this.lookupListBoxDisplayGroup = document.getElementById("lookupListBoxDisplayGroup");

    this.renderLookupGroupField();
    this.addClickEventListener();
  },

  renderLookupGroupField() {
    const lookupList = new Monet.UI.Fields.Render({
      name: 'groups',
      label: Monet.I18n.getResourcesByKey('event.action.managerNotification.sendToGroupsFieldLabel'),
      mandatory: false,
      type: 'LOOKUP_LIST',
      lookupEntity: 'Group',
      lookupEntityColumn: 'name',
    }).render();

    this.lookupListBoxDisplayGroup.appendChild(lookupList.rootEl);
    this.lookupListGroupField = lookupList;
  },

  addClickEventListener() {
    this.checkBoxDisplayPushNotification.addEventListener("click", () => {
      this.prepareElementsWhenClickedDisplayPushNotification();
    });

    this.checkBoxUseEventDescription.addEventListener("click", () => {
      this.prepareElementsWhenClickedUseEventDescription();
    });

    this.checkBoxUseEventMessageBody.addEventListener("click", () => {
      this.prepareElementsWhenClickedUseEventMessageBody();
    });
  },

  prepareElementsWhenClickedDisplayPushNotification() {
    const labels = document.querySelectorAll('#Event [id^="labelUseEvent"]');
    const checkboxes = [this.checkBoxUseEventDescription, this.checkBoxUseEventMessageBody];

    if (this.checkBoxDisplayPushNotification.checked) {
      Greenmile.Event.EventActionUtil.setAttribute('className', 'defaultColorElements', labels);
      Greenmile.Event.EventActionUtil.setAttribute('checked', true, checkboxes);
      Greenmile.Event.EventActionUtil.setAttribute('disabled', false, checkboxes);
    } else {
      this.notificationTitle.destroy();
      this.notificationBody.destroy();
      Greenmile.Event.EventActionUtil.setAttribute('className', 'customColorElements', labels);
      Greenmile.Event.EventActionUtil.setAttribute('checked', false, checkboxes);
      Greenmile.Event.EventActionUtil.setAttribute('disabled', true, checkboxes);
    }
  },

  prepareElementsWhenClickedUseEventDescription() {
    if (this.checkBoxUseEventDescription.checked) {
      this.notificationTitle.destroy();
    } else {
      this.notificationTitle.render();
    }
  },

  prepareElementsWhenClickedUseEventMessageBody() {
    if (this.checkBoxUseEventMessageBody.checked) {
      this.notificationBody.destroy();
    } else {
      this.notificationBody.render();
    }
  },

  notificationTitle: {
    render(value = '') {
      this.container = document.getElementById("customTitle");
      this.label = document.createElement('label');
      this.label.innerText = Monet.I18n.getResourcesByKey('event.action.managerNotification.customNotificationTitle');
      this.input = document.createElement('input');
      this.input.type = 'text';
      this.input.value = value || '';
      this.characterCount = document.createElement('div');
      this.characterCount.innerText = Monet.I18n.getResourcesByKey("event.textarea.charactersLeft", 100 - value.length);
      this.container.appendChild(this.label);
      this.container.appendChild(this.input);
      this.container.appendChild(this.characterCount);
      Greenmile.Event.EventActionUtil.addListenerToCountSizeInElement(this.input, this.characterCount,
        "event.textarea.charactersLeft", "EMAIL", 100);
    },
    destroy() {
      if (this.input) {
        while (this.container.children.length) {
          this.container.removeChild(this.container.children[0]);    
        }
        this.label = null;  
        this.input = null;
        this.characterCount = null;
      }
    },
    getValue() {
      return this.input ? this.input.value : '';
    }
  },

  notificationBody: {
    render(value = '') {
      this.container = document.getElementById("customBody");
      this.label = document.createElement('label');
      this.label.innerText = Monet.I18n.getResourcesByKey('event.action.managerNotification.customNotificationText');
      this.textArea = document.createElement('textarea');
      this.textArea.cols = 110;
      this.textArea.rows = 4;
      this.textArea.maxlength = 1000;
      this.textArea.value = value || '';
      this.characterCount = document.createElement('div');
      this.characterCount.innerText = Monet.I18n.getResourcesByKey("event.textarea.charactersLeft", 1000 - value.length);
      this.container.appendChild(this.label);
      this.container.appendChild(this.textArea);
      this.container.appendChild(this.characterCount);
      Greenmile.Event.EventActionUtil.addListenerToCountSizeInElement(this.textArea, this.characterCount,
        "event.textarea.charactersLeft", "EMAIL", 1000);
      this.showAddAttributesButton();
    },
    destroy() {
      if (this.textArea) {
        while (this.container.children.length) {
          this.container.removeChild(this.container.children[0]);    
        }
        this.label = null;  
        this.textArea = null;
        this.characterCount = null;
      }
    },
    getValue() {
      return this.textArea ? this.textArea.value : '';
    },
    showAddAttributesButton() {
      const selectFieldListAttributes = new Greenmile.Event.SelectFieldList("#customBody");
      selectFieldListAttributes.setAvailableTags(Greenmile.Event.AutoComplete.loadEmailAvailableTags());
      selectFieldListAttributes.addClickEventListener((field) => {
        if (field && (!this.textArea.value.includes(field.value))) {
          this.textArea.value += field.value;
  
          const event = document.createEvent("Event");
          event.initEvent("input");
          this.textArea.dispatchEvent(event);
        }
      });
  
      selectFieldListAttributes.render();
      this.container.appendChild(selectFieldListAttributes.elFieldList);
    }
  },

  assignParameter: function (jsonParam) {
    const {
      enabledPushNotification, usedEventDescription, usedEventMessageBody, title, text, groups
    } = (jsonParam) ? JSON.parse(jsonParam) : {};

    if (enabledPushNotification) {
      this.checkBoxDisplayPushNotification.checked = enabledPushNotification;
      this.checkBoxUseEventDescription.checked = usedEventDescription;
      this.checkBoxUseEventMessageBody.checked = usedEventMessageBody;
      this.checkBoxUseEventDescription.disabled = !enabledPushNotification;
      this.checkBoxUseEventMessageBody.disabled = !enabledPushNotification;
      this.lookupListGroupField.setValue(groups);

      const labels = document.querySelectorAll('#Event [id^="labelUseEvent"]');
      Greenmile.Event.EventActionUtil.setAttribute('className', 'defaultColorElements', labels);

      if (!usedEventDescription) {
        this.notificationTitle.render(title);
      }

      if (!usedEventMessageBody) {
        this.notificationBody.render(text);
      }
    }
  },

  retrieveParameter() {
    return JSON.stringify({
      enabledPushNotification: this.checkBoxDisplayPushNotification.checked,
      usedEventDescription: this.checkBoxUseEventDescription.checked,
      usedEventMessageBody: this.checkBoxUseEventMessageBody.checked,
      title: this.notificationTitle.getValue(),
      text: this.notificationBody.getValue(),
      groups: this.lookupListGroupField.getValue()
    });
  }
};
